import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as homePageActions from "../../actions/homePageActions";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Tabs, Tab, Accordion, Card, useAccordionButton } from "react-bootstrap";
import PropTypes from "prop-types";

function CustomToggle({ children, eventKey, handleClick }) {
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    handleClick();
  });

  return (
    <Accordion.Toggle eventKey={eventKey + 1} onClick={decoratedOnClick}>{children}</Accordion.Toggle>
  );
}

CustomToggle.propTypes = {
  children: PropTypes.node.isRequired,
  eventKey: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
}

const Index = (props) => {

  const { actions, faqData, title, setting } = props;
  const [keyword, setKeyword] = useState("");
  const history = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [activeKey, setActiveKey] = useState(0);

  const siteName = setting?.name?.trim() || "Frequently Asked Questions";

  useEffect(() => {
    const title = `${siteName} - Login to Your Account`;

    document.title = title;

    const fetchData = () => {
      actions.loadFaqData();
      window.scrollTo(0, 0);
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "Want to know more about our unique mentoring platform? Read the frequently asked questions and reach out to us."
        );
    };
    fetchData();
  }, [siteName, actions, title]);

  useEffect(() => {
    const elements = document.querySelectorAll('.faq_text_content a');
    for (const element of elements) {
      element.removeAttribute('target');
    }
  }, [faqData]);

  const handleClickSearch = () => {
    params.set("keyword", keyword);
    history({
      pathname: "/faqapp",
      search: "?" + params,
    });
    actions.loadFaqData({ keyword: keyword });
  };

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  const resetPage = () => {
    setKeyword("");
    history(`/faqapp`);
    actions.loadFaqData();
  };

  return (
    <div>
      <section className="outer_main faq_page_main">
        <Container className="">
          <div className="faq_page">
            <div className="help_form_head">
              <h1>How can we help</h1>
              <div className="help_search">
                <button className="btn" onClick={() => handleClickSearch()}>
                  <i className="fas fa-search"></i>
                </button>
                <input
                  type="text"
                  value={keyword}
                  className="form-control"
                  placeholder="Search by question..."
                  onChange={(event) => {
                    setKeyword(event.target.value);
                  }}
                />
              </div>
            </div>
            {params.get('keyword') ? (
              <div className="faq-tabs">
                <Accordion defaultActiveKey="1">
                  <p> Search by <strong>"{params.get('keyword')}"</strong>&nbsp;&nbsp;
                    <a href="javascript" onClick={resetPage} className="link ms-auto">
                      Reset Filters
                    </a>
                  </p>
                  {faqData && faqData.length > 0 &&
                    faqData.map((item, key) => (
                      <div key={item.id}>
                        <div className="faq_tabs_main">
                          <CustomToggle
                            as={Card.Header}
                            eventKey={key + 1}
                            handleClick={() => {
                              if (activeKey === key + 1) {
                                setActiveKey(null);
                              } else {
                                setActiveKey(key + 1);
                              }
                            }}
                          >
                            {item.title}
                            {activeKey === key + 1 ? <span className='collapse_toggle_inner'><i className="fas fa-minus"></i></span> : <span className='collapse_toggle_inner'><i className="fas fa-plus"></i></span>}
                          </CustomToggle>
                          <Accordion.Collapse eventKey={key + 1}>
                            <Card.Body>
                              <div
                                dangerouslySetInnerHTML={prepareHtml(
                                  item.description
                                )}
                              ></div>
                            </Card.Body>
                          </Accordion.Collapse>
                        </div>
                      </div>
                    ))}
                </Accordion>
                {faqData.length === 0 && (
                  <div className="text-center">No data found.</div>
                )}
              </div>

            ) : (

              <Tabs
                defaultActiveKey="generalqueries"
                id="uncontrolled-tab-example"
              >
                {/* General-Queries */}
                <Tab eventKey="generalqueries" title="General Queries">

                  <div className="faq-tabs">
                    <Accordion defaultActiveKey="1">
                      <h2 className="title">General Queries</h2>
                      {faqData && faqData.length > 0 &&
                        faqData.map((item, key) => (
                          <div key={item.id}>
                            {item.type === 'General Queries' && (
                              <div className="faq_tabs_main">
                                <CustomToggle
                                  as={Card.Header}
                                  eventKey={key + 1}
                                  handleClick={() => {
                                    if (activeKey === key + 1) {
                                      setActiveKey(null);
                                    } else {
                                      setActiveKey(key + 1);
                                    }
                                  }}
                                >
                                  {item.title}
                                  {activeKey === key + 1 ? <span className='collapse_toggle_inner'><i className="fas fa-minus"></i></span> : <span className='collapse_toggle_inner'><i className="fas fa-plus"></i></span>}
                                </CustomToggle>
                                <Accordion.Collapse eventKey={key + 1}>
                                  <Card.Body>
                                    <div
                                      dangerouslySetInnerHTML={prepareHtml(
                                        item.description
                                      )}
                                    ></div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </div>
                            )}
                          </div>
                        ))}
                    </Accordion>
                  </div>
                </Tab>

                {/* Mentor Queries */}
                <Tab eventKey="mentorqueries" title="Mentor Queries">
                  <div className="faq-tabs">
                    <Accordion defaultActiveKey="0">
                      <h2 className="title">Mentors’ Queries</h2>

                      {faqData && faqData.length > 0 &&
                        faqData.map((item, key) => (
                          <div key={item.id}>
                            {item.type === 'Mentor Queries' && (
                              <div className="faq_tabs_main">
                                <CustomToggle
                                  as={Card.Header}
                                  eventKey={key + 1}
                                  handleClick={() => {
                                    if (activeKey === key + 1) {
                                      setActiveKey(null);
                                    } else {
                                      setActiveKey(key + 1);
                                    }
                                  }}
                                >
                                  {item.title}
                                  {activeKey === key + 1 ? <span className='collapse_toggle_inner'><i className="fas fa-minus"></i></span> : <span className='collapse_toggle_inner'><i className="fas fa-plus"></i></span>}
                                </CustomToggle>
                                <Accordion.Collapse eventKey={key + 1}>
                                  <Card.Body>
                                    <div
                                      dangerouslySetInnerHTML={prepareHtml(
                                        item.description
                                      )}
                                    ></div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </div>
                            )}
                          </div>
                        ))}
                    </Accordion>
                  </div>
                </Tab>

                {/* Mentee Queries */}
                <Tab eventKey="menteequeries" title="Mentee Queries">
                  <div className="faq-tabs">
                    <Accordion defaultActiveKey="0">
                      <h2 className="title">Mentees Queries</h2>
                      {faqData &&
                        faqData.length > 0 &&
                        faqData.map((item, key) => (
                          <div key={item.id}>
                            {item.type === 'Mentee Queries' && (
                              <div className="faq_tabs_main">
                                <CustomToggle
                                  as={Card.Header}
                                  eventKey={key + 1}
                                  handleClick={() => {
                                    if (activeKey === key + 1) {
                                      setActiveKey(null);
                                    } else {
                                      setActiveKey(key + 1);
                                    }
                                  }}
                                >
                                  {item.title}
                                  {activeKey === key + 1 ? <span className='collapse_toggle_inner'><i className="fas fa-minus"></i></span> : <span className='collapse_toggle_inner'><i className="fas fa-plus"></i></span>}
                                </CustomToggle>
                                <Accordion.Collapse eventKey={key + 1}>
                                  <Card.Body>
                                    <div
                                      dangerouslySetInnerHTML={prepareHtml(
                                        item.description
                                      )}
                                    ></div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </div>
                            )}
                          </div>
                        ))}
                    </Accordion>
                  </div>
                </Tab>
              </Tabs>
            )}
          </div>
        </Container>
      </section>
    </div>
  );
};

Index.propTypes = {
  actions: PropTypes.shape({
    loadFaqData: PropTypes.func.isRequired,
  }).isRequired,
  faqData: PropTypes.shape({
    length: PropTypes.number,
    map: PropTypes.func,
  }).isRequired,
  title: PropTypes.string,
  setting: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    faqData: state.faqData,
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...homePageActions}, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
